import { Route, Routes } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import Header from "./components/Header";
import Footer from "./components/Footer";
import Candidate from "./pages/technology/Candidate";
import Home from "./pages/Home";
import About from "./pages/About";
import Publications from "./pages/Publications";
import Contact from "./pages/Contact";
import Privacy from "./pages/Privacy";
import LeadIndications from "./pages/technology/LeadIndications";
import STARS from "./pages/trials/STARS";
import CoSTARS from "./pages/trials/CoSTARS";
import Media from "./pages/Media";
// Individual (7) media pages
import NatureArticle from "./pages/media/nature";
import ABCNews from "./pages/media/abc";
import JPMorganArticle from "./pages/media/jpmorgan";
import NineNews from "./pages/media/ninenews";
import NbnNews from "./pages/media/nbnnews";
import NewcastleHerald from "./pages/media/newcastleherald";
import GordonResearchConference from "./pages/media/gordonresearchconference";
import BoardOfDirectors from "./pages/leadership/BoardOfDirectors";
import SeniorManagement from "./pages/leadership/SeniorManagement";
import CorporateAdvisors from "./pages/leadership/CorporateAdvisors";
// Individual leadership profile pages
import DavidMazzo from "./pages/leadership/DavidMazzo";
import ShaunJackson from "./pages/leadership/ShaunJackson";
import PeterBush from "./pages/leadership/PeterBush";
import SundeepDugar from "./pages/leadership/SundeepDugar";
import SimoneSchoenwaelder from "./pages/leadership/SimoneSchoenwaelder";
import AmosMeltzer from "./pages/leadership/AmosMeltzer";
import SimonJackson from "./pages/leadership/SimonJackson";
import RodJackson from "./pages/leadership/RodJackson";
import MithranDoraisamy from "./pages/leadership/MithranDoraisamy";
import NotFound from "./pages/404";
import ScrollToTop from "./components/ScrollToTop";
import ScrollProgressBar from "./components/ScrollProgressBar";
import AnalyticsListener from "./components/AnalyticsListener";
import OutboundLinkListener from "./components/OutboundLinkListener";

export default function App() {
  // Create a helmet context
  const helmetContext = {};

  return (
    <HelmetProvider context={helmetContext}>
      <div className="min-h-dvh flex flex-col">
        <ScrollProgressBar />
        <Header />
        <div className="flex-grow relative">
          <ScrollToTop />
          <AnalyticsListener />
          <OutboundLinkListener />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/leadership/board-of-directors" element={<BoardOfDirectors />} />
            <Route path="/leadership/senior-management" element={<SeniorManagement />} />
            <Route path="/leadership/corporate-advisors" element={<CorporateAdvisors />} />
            {/* Individual leadership profile routes */}
            <Route path="/leadership/david-mazzo" element={<DavidMazzo />} />
            <Route path="/leadership/shaun-jackson" element={<ShaunJackson />} />
            <Route path="/leadership/peter-bush" element={<PeterBush />} />
            <Route path="/leadership/sundeep-dugar" element={<SundeepDugar />} />
            <Route path="/leadership/simone-schoenwaelder" element={<SimoneSchoenwaelder />} />
            <Route path="/leadership/amos-meltzer" element={<AmosMeltzer />} />
            <Route path="/leadership/simon-jackson" element={<SimonJackson />} />
            <Route path="/leadership/rod-jackson" element={<RodJackson />} />
            <Route path="/leadership/mithran-doraisamy" element={<MithranDoraisamy />} />
            <Route path="/media" element={<Media />} />
            <Route path="/media/nature" element={<NatureArticle />} />
            <Route path="/media/abc" element={<ABCNews />} />
            <Route path="/media/jpmorgan" element={<JPMorganArticle />} />
            <Route path="/media/ninenews" element={<NineNews />} />
            <Route path="/media/nbnnews" element={<NbnNews />} />
            <Route path="/media/newcastleherald" element={<NewcastleHerald />} />
            <Route path="/media/gordonresearch" element={<GordonResearchConference />} />
            <Route path="/trials/stars" element={<STARS />} />
            <Route path="/trials/costars" element={<CoSTARS />} />
            <Route path="/publications/*" element={<Publications />} />
            <Route path="/technology/candidate" element={<Candidate />} />
            <Route path="/technology/leadIndication" element={<LeadIndications />} />
            {/* 404 page - catches all unmatched routes */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </HelmetProvider>
  );
}